export const cilDataTransferDown = ["24 24","<path d='M0.75 21.75h22.5v1.5h-22.5v-1.5z'></path><path d='M18.53 14.030l-1.061-1.061-4.345 4.345v-16.564h-1.5v16.564l-4.345-4.345-1.061 1.061 6.155 6.155 6.155-6.155z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-data-transfer-down.js
// module id = null
// module chunks = 